// Librerias
import React, { Component } from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
import SelectRange from '../../components/shared/SelectRangeVirtualTable.jsx'
// API
import api from '../../apiClient/v1'
import API from '../../apiClient/v2'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
import * as css from './modal.css'
let cx = classNames.bind(cssModal)
import * as cssOperador from '../../nominas/nominaIG/components/PanelCaptador.css'
import BlackBoxAPI from './BlackBoxAPI.js'
import { TablaAPI } from './TablaAPI.jsx'
const format = 'YYYY-MM-DD'

export class ModalTrigger extends Component {
    constructor(props) {
        super(props)
        this.state = { visible: false }
        this.show = () => this.setState({ visible: true })
        this.hide = () => this.setState({ visible: false })
    }
    render() {
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalPDALider extends Component {
    constructor(props) {
        super(props)
        this.blackbox = new BlackBoxAPI()
        this.state = {
            idLider: this.props.lideres[0]['valor'],
            detallesFiltrados: [],
            filtros: {},
            fechaInicio: this.props.fechaInicial,
            fechaFin: this.props.fechaFinal,
            lideres: this.props.lideres,
            totalDisponible: 0,
            totalReal: 0,
            totalNecesarias: 0,
            totalExcedente: 0,
            totalFaltantes: 0
        }
        this.fetchDetalle = () => {
            api.activoFijo.getResumenPDA(this.state.idLider, this.state.fechaInicio, this.state.fechaFin)
                .then(detalles => {
                    this.blackbox.reset()
                    detalles.forEach(detalle => this.blackbox.add(detalle))
                    this.blackbox.ordenarLista()
                    this.setState(this.blackbox.getListaFiltrada())
                })
                .catch(meh => { })
        }
    }
    actualizarFiltro(nombreFiltro, filtro) {
        this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
        this.setState(this.blackbox.getListaFiltrada())
    }

    componentWillMount() {
        this.fetchDetalle()
    }

    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPDALider')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <table>
                        <tr className={css.modalPDATotalesRow}>
                            <td className={css.modalPDATotales} title='Total de PDA que poseen los lideres'>Total PDA en terreno: {this.state.totalReal} </td>
                            <td className={css.modalPDATotalesBorde} title='Total de PDA que necesitan los lideres para los inventarios'>Total PDA necesarias: {this.state.totalNecesarias} </td>
                            <td className={css.modalPDATotalesBorde} title='Cantidad de PDA que necesitan los lideres para realizar los inventarios'>Total PDA a suministrar: {this.state.totalFaltantes} </td>
                            <td className={css.modalPDATotalesBorde} title='Cantidad de PDA extra que poseen los líderes'>Total PDA excedente en terreno: {this.state.totalExcedente} </td>
                            <td className={css.modalPDATotalesBorde} title='Cantidad de PDA disponibles en la bodega oficina'>Total PDA disponible bodega SEI: {this.state.totalDisponible} </td>
                        </tr>
                    </table>
                </Modal.Header>
                <Modal.Body>
                    <TablaAPI
                        detalle={this.state.detallesFiltrados}
                        filtros={this.state.filtros}
                        actualizarFiltro={this.actualizarFiltro.bind(this)}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalSolicitudDotacion extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fechaInicio: this.props.fechaInicial,
            fechaFin: this.props.fechaFinal,
            nominas: []
        }
        this.fetchDetalle = () => {
            api.nominas.getPorRangoYSolicitud(this.state.fechaInicio, this.state.fechaFin)
                .then(nominas => {
                    this.setState({ nominas: nominas })
                })
                .catch(meh => { })
        }
        this.onClickSolicitud = (idNomina, estado) => {
            api.nomina(idNomina).estadoSolicitud(estado)
                .then(this.fetchDetalle())
                .catch(meh => { })
        }

    }
    componentWillMount() {
        this.fetchDetalle()
    }

    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalAumentoDot')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <span className="glyphicon glyphicon-plus-sign"></span> Solicitudes aumento dotación
                </Modal.Header>
                <Modal.Body>
                    <TablaSolicitudes
                        nominas={this.state.nominas}
                        onClickSolicitud={this.onClickSolicitud}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalSolicitudCambioNomina extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fechaInicio: this.props.fechaInicial,
            fechaFin: this.props.fechaFinal,
            nominas: []
        }
        this.fetchNominasPendientes = () => {
            api.nominas.getSolicitudesCambio(this.state.fechaInicio, this.state.fechaFin)
                .then(resp => {
                    console.log(resp)
                    this.setState({
                        nominas: resp
                    })
                })
                .catch(err => {
                    console.log(err)
                })
        }
        this.aprobarSolicitudCambio = (idNomina, operador, operadorNuevo) => {
            api.nomina(idNomina).cambioEstadoSolicitud(operador, operadorNuevo, true)
                .then(resp => {
                    this.fetchNominasPendientes()
                    this.props.pendientes()
                })
                .catch(err => {
                    console.log(err)
                })
        }
        this.rechazarSolicitudCambio = (idNomina, operador, operadorNuevo) => {
            api.nomina(idNomina).cambioEstadoSolicitud(operador, operadorNuevo, false)
                .then(resp => {
                    this.fetchNominasPendientes()
                    this.props.pendientes()
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
    componentWillMount() {
        this.fetchNominasPendientes()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalCambioDot')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <span className="glyphicon glyphicon-plus-sign"></span> Solicitud reemplazo operador nuevo
                </Modal.Header>
                <Modal.Body>
                    <NominasPendientes
                        nominas={this.state.nominas}
                        aprobar={this.aprobarSolicitudCambio}
                        rechazar={this.rechazarSolicitudCambio}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}

export function ModalMasivoNominas({hideModal, informar, rectificar}) {
    const handleInformar = () => {
        console.log("informar");
        hideModal();
    }

    const handleInformarSinCorreo = () =>{
        console.log("informar sin correo");
        hideModal();
    }

    const handleRectificar = () => {
        console.log("rectificar");
        hideModal();
    }
    return (
        <Modal show={true} onHide={hideModal} dialogClassName={cx('modalEnvioNominas')} className={cx('modale')}>
            <Modal.Header closeButton>
                <span className="glyphicon glyphicon-user"></span> Cambios en Nóminas Informadas
            </Modal.Header>
            <Modal.Body>
                <button onClick={handleInformar} >Informar</button>
                <button onClick={handleRectificar}>Rectificar</button>
                <button onClick={handleInformarSinCorreo}>Informar (sin Correo)</button>
            </Modal.Body>
        </Modal>
    );

}

export class ModalCambiosNomina extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fechaInicio: this.props.fechaInicial,
            fechaFin: this.props.fechaFinal,
            nominas: [],
            enviando: false,
            error: ''
        }
        this.fetchNominasPendientes = () => {
            api.nominas.getCambiosNominas(this.state.fechaInicio, this.state.fechaFin)
                .then(resp => {
                    this.setState({
                        nominas: resp
                    })
                })
                .catch(err => {
                    console.log(err)
                })
        }
        this.aprobarCambio = (idNomina) => {
            this.setState({ enviando: true })
            api.nomina(idNomina).completarSinCorreo()
                .then(resp => {
                    api.nomina(idNomina).cambioNominaInformada(true)
                        .then(resp => {
                            console.log("Nómina " + idNomina + "informada correctamente")
                        })
                        .catch(err => {
                            console.log(err)
                            this.setState({
                                enviando: false,
                                error: "Ocurrió un error al aceptar los cambios, intente nuevamente"
                            })
                        })
                    this.fetchNominasPendientes()
                    this.setState({
                        enviando: false,
                        error: ''
                    })
                })
                .catch(err => {
                    console.log(err)
                    this.setState({
                        enviando: false,
                        error: err.data.idNomina
                    })
                })
        }
        this.aprobarCambioCorreo = (idNomina) => {
            this.setState({ enviando: true })
            api.nomina(idNomina).informar()
                .then(resp => {
                    api.nomina(idNomina).cambioNominaInformada(true)
                        .then(resp => {
                            console.log("Nómina " + idNomina + "informada correctamente")
                        })
                        .catch(err => {
                            console.log(err)
                            this.setState({
                                enviando: false,
                                error: "Ocurrió un error al aceptar los cambios, intente nuevamente"
                            })
                        })
                    this.fetchNominasPendientes()
                    this.setState({
                        enviando: false,
                        error: ''
                    })
                })
                .catch(err => {
                    console.log(err)
                    this.setState({
                        enviando: false,
                        error: err.data.idNomina
                    })
                })
        }
        this.rechazarCambio = (idNomina) => {
            this.setState({ enviando: true })
            api.nomina(idNomina).cambioNominaInformada(false)
                .then(resp => {
                    console.log(resp)
                    api.nomina(idNomina).rechazar()
                    this.fetchNominasPendientes()
                    this.setState({ enviando: false })
                })
                .catch(err => {
                    console.log(err)
                    this.setState({ enviando: false })
                })
        }
    }
    componentWillMount() {
        this.fetchNominasPendientes()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalCambiosNomina')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <span className="glyphicon glyphicon-user"></span> Cambios en Nóminas Informadas
                </Modal.Header>
                <Modal.Body>
                    {this.state.error && <div className="alert alert-danger" role="alert">{this.state.error}</div>}
                    <table className="table table-bordered">
                        <tbody>
                            {this.state.nominas.map((list, index) => {
                                return (
                                    <tr className={cssModal.trSeparator}>
                                        <Nomina
                                            key={index}
                                            nomina={list}
                                            aprobar={this.aprobarCambio}
                                            aprobarCorreo={this.aprobarCambioCorreo}
                                            rechazar={this.rechazarCambio}
                                            enviando={this.state.enviando}
                                        />
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalPublicarInventarios extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPDALider')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Publicar inventarios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>ATENCIÓN, se publicarán los inventarios filtrados en programación IG, ¿Desea proceder?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-warning pull-left"
                            onClick={this.props.publicarInventario}>
                            <span className="glyphicon glyphicon-envelope" /> Publicar
                        </button>
                    </div>
                    <div className="col-md-6">
                        <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove" /> Cancelar</button>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
export class ModalPublicacionIG extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fechaInicialSeleccionada: this.props.fechaInicial,
            fechaFinalSeleccionada: this.props.fechaFinal,
            inventarios: [],
            cantidadPendientes: ''
        }
        this.onClickPublicar = (estatus) => {
            let fechaInicio = this.state.fechaInicialSeleccionada.format(format)
            let fechaFin = this.state.fechaFinalSeleccionada.format(format)
            api.inventario.publicarProgramacion(fechaInicio, fechaFin, estatus)
                .then(this.buscarInventarios)
                .catch(meh => { })
        }
    }
    buscarInventarios = () => {
        let fechaInicio = this.state.fechaInicialSeleccionada.format(format)
        let fechaFin = this.state.fechaFinalSeleccionada.format(format)
        this.setState({ inventarios: [] })
        api.inventario.buscarPorPublicar(fechaInicio, fechaFin, 0)
            .then(result => {
                let cantidadPendientes = result.inventarios.filter(pendientes => pendientes.inv_estadoPublicacion === 1 || pendientes.inv_estadoPublicacion === 3)
                this.setState({ inventarios: result.inventarios, cantidadPendientes: cantidadPendientes.length })
            })
    }
    onSelectRangoChanged = (momentumFechaInicio, momentumFechaFinal) => {
        this.setState({
            fechaInicialSeleccionada: momentumFechaInicio,
            fechaFinalSeleccionada: momentumFechaFinal
        }, () => {
            this.buscarInventarios()

        })
    }
    componentWillMount() {
        this.buscarInventarios()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPublicacionIG')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <span className="glyphicon glyphicon-bookmark"></span> Publicación programación de inventarios
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <SelectorRango
                            fechaInicial={this.state.fechaInicialSeleccionada}
                            fechaFinal={this.state.fechaFinalSeleccionada}
                            onSelectRangoChanged={this.onSelectRangoChanged}
                        />
                        <div className="col-md-6">
                            <BotonDespublicar
                                disabled={this.state.cantidadPendientes === this.state.inventarios.length}
                                onClickPublicar={this.onClickPublicar}
                            />
                            <BotonPublicar
                                disabled={this.state.cantidadPendientes === 0}
                                onClickPublicar={this.onClickPublicar}
                            />
                            <BadgePendientes
                                cantidadPendientes={this.state.cantidadPendientes}
                            />
                        </div>
                    </div>
                    <InventariosPublicacion
                        inventarios={this.state.inventarios}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalAdminStatusService extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initDate: this.props.initDate,
            finishDate: this.props.finishDate,
            services: [],
            idClient: 1
        }
        this.searchServices = () => {
            let initDate = this.state.initDate.format(format)
            let finishDate = this.state.finishDate.format(format)
            API.billing().getServices(this.state.idClient, initDate, finishDate)
                .then(result => {
                    this.setState({ services: result.services })
                })
        }
        this.onSelectRangeChanged = (momentInitDate, momentFinishDate) => {
            this.setState({
                initDate: momentInitDate,
                finishDate: momentFinishDate
            }, () => {
                this.searchServices()

            })
        }
        this.onSelectClientChanged = (evt) => {
            let idClient = evt.target.value
            this.setState({
                idClient: idClient
            }, () => {
                this.searchServices()
            })
        }
        this.onChangeStatusService = (idService, idStatus) => {
            api.inventario.updateStatus(idService, idStatus)
                .then(result => {
                    this.searchServices()
                })
        }
    }
    componentDidMount() {
        this.searchServices()
    }
    render() {
        const h5Style = {
            color: 'peru'
        };
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalAdminBilling')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Administración de estados de inventario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-11">
                            <SelectorCliente
                                idClienteSeleccionado={this.state.idClient}
                                seleccionarCliente={this.onSelectClientChanged}
                                clientes={this.props.clients}
                            />
                            <SelectorRango
                                fechaInicial={this.state.initDate}
                                fechaFinal={this.state.finishDate}
                                onSelectRangoChanged={this.onSelectRangeChanged}
                            />
                        </div>
                    </div>
                    <ServicesForBilling
                        services={this.state.services}
                        onChangeStatusService={this.onChangeStatusService}
                    />
                    <h5 style={h5Style}>Para su información las peticiones de ordenes de compra se envían a las 12 HRS cada día, donde se incluyen solo los servicios en estado FACTURABLE.</h5>
                </Modal.Body>
            </Modal>
        )
    }
}
export const ModalApproveReview = ({ hideModal, initDate, finishDate, acceptAction }) => {
    return (
        <Modal show={true} onHide={hideModal} dialogClassName={cx('modalApproveReview')}>
            <Modal.Header closeButton>
                <span className="glyphicon glyphicon-info-sign"></span>{` Envío automatizado de nóminas desde ${initDate} hasta ${finishDate}`}
            </Modal.Header>
            <Modal.Body>
                <h4>Al aceptar la acción se informaran las nóminas del rango seleccionado, siempre y cuando se cumplan las validaciones del negocio.</h4>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-success" onClick={() => acceptAction(true)}>Correo</button>
                <button type="button" className="btn btn-warning" onClick={() => acceptAction(false)}>Sin Correo</button>
                <button type="button" className="btn btn-secondary" onClick={hideModal}>Cancelar</button>
            </Modal.Footer>
        </Modal>
    )
}

// SELECTS
const SelectorCliente = ({ idClienteSeleccionado, seleccionarCliente, clientes }) =>
    <div className="col-sm-4 form-group ">
        <label className="control-label" htmlFor="cliente">Clientes</label>
        <select className="form-control" name="clientes"
            value={idClienteSeleccionado}
            onChange={seleccionarCliente}
        >
            {clientes.map(cliente =>
                <option key={cliente.idCliente} value={cliente.idCliente}>{`${cliente.nombreCorto}`}</option>
            )}
        </select>
    </div>

const SelectorRango = ({ fechaInicial, fechaFinal, onSelectRangoChanged }) =>
    <div className={'col-sm-6 form-group '}>
        <label className="control-label" htmlFor="selectSemana">Rango de Fecha</label>
        <SelectRange
            startDateSelected={fechaInicial}
            endDateSelected={fechaFinal}
            onInit={() => { console.log("on init") }}
            onRangeSelected={onSelectRangoChanged.bind(this)}
        />
    </div>

const SelectStatusService = ({ service, onChangeStatusService }) =>
    <div>
        <select className="form-control"
            value={service.service_status_id}
            onChange={(evt) => onChangeStatusService(service.service_id, evt.target.value)}
        >
            <option key={1} value={1}>Creado</option>
            <option key={2} value={2}>Suspendido</option>
            <option key={3} value={3}>Mal Realizado</option>
            <option key={4} value={4}>Facturable</option>
            <option key={5} value={5}>No Facturable</option>
            <option key={6} value={6}>Facturación Especial</option>
            <option key={7} value={7}>Rechazado</option>
        </select>
    </div>

// TABLES
const InventariosPublicacion = ({ inventarios }) =>
    <div style={{ height: '80%' }} className="row">
        <AutoSizer>
            {({ height, width }) =>
                <Table
                    // general
                    height={height}
                    width={width}
                    // headers
                    headerHeight={30}
                    headerClassName={css.headerColumn}
                    // rows
                    rowCount={inventarios.length}
                    rowGetter={({ index }) => inventarios[index]}
                    rowHeight={30}
                    rowClassName={({ index }) => index < 0 ? css.headerRow : ((index % 2 === 0) ? css.evenRow : css.oddRow)}
                >
                    {/* CLIENTES */}
                    <Column
                        dataKey='cliente_nombreCorto' label="CL"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={80}
                    />
                    {/* FECHAS */}
                    <Column
                        dataKey='inv_fechaProgramadaF' label="Fecha"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={190}
                    />
                    {/* CECO */}
                    <Column
                        dataKey='local_ceco' label="CECO"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={80}
                    />
                    {/* LOCAL */}
                    <Column
                        dataKey='local_nombre' label="Local"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={300}
                    />
                    {/* COMUNA */}
                    <Column
                        dataKey='local_comuna' label="Comuna"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={200}
                    />
                    {/* REGION */}
                    <Column
                        dataKey='local_region' label="Region"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={80}
                    />
                    <Column
                        dataKey='inv_estadoPublicacion' label="Estado"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => {
                            if (rowData[dataKey] === 2) {
                                return <h4><span className="label label-success">PUBLICADO</span></h4>
                            }
                            else if (rowData[dataKey] === 3) {
                                return <h4><span className="label label-info">MODIFICADO</span></h4>

                            }
                            else {
                                return <h4><span className="label label-warning">PENDIENTE</span></h4>
                            }
                        }
                        }
                        width={120}
                    />
                </Table>
            }
        </AutoSizer>
    </div>

const ServicesForBilling = ({ services, onChangeStatusService }) => {
    return (
        <div style={{ height: '80%' }} className="row">
            <AutoSizer>
                {({ height, width }) =>
                    <Table
                        // general
                        height={height}
                        width={width}
                        // headers
                        headerHeight={30}
                        headerClassName={css.headerColumn}
                        // rows
                        rowCount={services.length}
                        rowGetter={({ index }) => services[index]}
                        rowHeight={30}
                        rowClassName={({ index }) => index < 0 ? css.headerRow : ((index % 2 === 0) ? css.evenRow : css.oddRow)}
                    >
                        {/* DATE */}
                        <Column
                            dataKey='service_date' label="Fecha"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                            width={190}
                        />
                        {/* CECO */}
                        <Column
                            dataKey='store_ceco' label="CECO"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                            width={80}
                        />
                        {/* STORE */}
                        <Column
                            dataKey='store_name' label="Local"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                            width={260}
                        />
                        {/* COMUNA */}
                        <Column
                            dataKey='store_comuna' label="Comuna"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                            width={200}
                        />
                        {/* UNIT COUNTED */}
                        <Column
                            dataKey='units_counted' label="UND"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                                rowData[dataKey].toLocaleString("es-CL")
                            }
                            width={80}
                        />
                        {/* UNIT VALUE */}
                        <Column
                            dataKey='unit_value' label="FACTOR"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                            width={80}
                        />
                        {/* TOTAL */}
                        <Column
                            dataKey='total_billing' label="TOTAL"
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                                rowData[dataKey].toLocaleString("es-CL", { style: "currency", currency: "CLP" })
                            }
                            width={80}
                        />
                        {/* STATUS */}
                        <Column
                            dataKey='' label='Estado'
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                <div>
                                    <SelectStatusService
                                        service={rowData}
                                        onChangeStatusService={onChangeStatusService}
                                    />
                                </div>

                            )}
                            width={150}
                        />
                        {/* IS BILLING */}
                        <Column
                            dataKey='' label=''
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                <div>
                                    <ButtonIsBilling
                                        service={rowData}
                                        buttonClassName={rowData['is_billing'] ? 'btn btn-sm btn-success' : 'btn btn-sm btn-warning'}
                                    />
                                </div>

                            )}
                            width={50}
                        />
                        {/* LABEL */}
                        <Column
                            dataKey='' label=''
                            cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                <div>
                                    <ButtonOptionService
                                        service={rowData}
                                        buttonClassName={rowData['billing_request_id'] ? 'btn btn-sm btn-success' : 'btn btn-sm btn-warning'}
                                    />
                                </div>

                            )}
                            width={50}
                        />
                    </Table>
                }
            </AutoSizer>
        </div>
    )
}

const TablaSolicitudes = ({ nominas, onClickSolicitud }) =>
    <div style={{ height: '40%' }} className="row">
        <AutoSizer>
            {({ height, width }) =>
                <Table
                    // general
                    height={height}
                    width={width}
                    // headers
                    headerHeight={30}
                    headerClassName={css.headerColumnAumentoDot}
                    // rows
                    rowCount={nominas.length}
                    rowGetter={({ index }) => nominas[index]}
                    rowHeight={30}
                    rowClassName={({ index }) => index < 0 ? css.headerRow : ((index % 2 === 0) ? css.evenRow : css.oddRow)}
                >
                    {/* FECHAS */}
                    <Column
                        dataKey='inv_fechaProgramadaF' label="FECHA"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={180}
                    />
                    {/* CLIENTE */}
                    <Column
                        dataKey='cliente_nombreCorto' label="CL"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={80}
                    />
                    {/* CECO */}
                    <Column
                        dataKey='local_numero' label="CE"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={80}
                    />
                    {/* TOTAL INVENTARIOS DIA*/}
                    <Column
                        dataKey='local_region' label="RG"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={100}
                    />
                    {/* TOTAL OPERADORES NOCHE*/}
                    <Column
                        dataKey='local_nombre' label="TIENDA"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={250}
                    />
                    {/* TOTAL OPERADORES DIA*/}
                    <Column
                        dataKey='inv_stock' label="STOCK ACTUAL"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='inv_stock_ultimo' label="ULTIMO CONTEO"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='inv_dot_ultimo' label="ULTIMA DOT."
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='inv_tiempo_ultimo' label="HRS CONTEO"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='dotacionOperadores' label="ACTUAL DOT."
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='diferenciaSolicitud' label="SOLICITUD"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='dotacionSolicitud' label="NUEVA DOT."
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='comentarioDotacion' label="Coment."
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={160}
                    />
                    <Column
                        dataKey='idNomina'
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                            <BotonAprobar
                                idNomina={rowData[dataKey]}
                                onClickSolicitud={onClickSolicitud}
                                estado={4}
                            />
                        }
                        width={100}
                    />
                    <Column
                        dataKey='idNomina'
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                            <BotonRechazar
                                idNomina={rowData[dataKey]}
                                onClickSolicitud={onClickSolicitud}
                                estado={5}
                            />
                        }
                        width={100}
                    />

                </Table>
            }
        </AutoSizer>
    </div>

const Nomina = ({ nomina, aprobar, aprobarCorreo, rechazar, enviando }) =>
    <div className="form-group">
        <div className="col-md-12">
            <label className="col-md-6 control-label">Fecha Inv.: {nomina.inv_fechaProgramadaF}</label>
            <label className="col-md-3 control-label">Región: {nomina.local_region}</label>
            <label className="col-md-3 control-label">Comuna: {nomina.local_comuna}</label>
        </div>
        <div className="col-md-12">
            <label className="col-md-4 control-label">Cliente: {nomina.cliente_nombreCorto}</label>
            <label className="col-md-4 control-label">CECO: {nomina.local_numero}</label>
            <label className="col-md-4 control-label">Tienda: {nomina.local_nombre}</label>
        </div>
        {nomina.cantCambiosTitular > 0 ?
            <div className="col-md-6">
                <div className="panel panel-success">
                    <div className={cx("panel-heading", 'panelHeading')}>Dotación Titular</div>
                    <div className="panel-body">
                        <table className={'table table-striped table-bordered table-hover table-condensed ' + cssOperador.tablaDotacion}>
                            <colgroup>
                                <col className={cssOperador.colNombreM} />
                                <col className={cssOperador.colExp} />
                                <col className={cssOperador.colError} />
                                <col className={cssOperador.colConteoReal} />
                                <col className={cssOperador.colConteo} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th colSpan={3}>&nbsp;</th>
                                    <th className={cssOperador.thConteoSpan} colSpan={2}>Conteo</th>
                                </tr>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Exp</th>
                                    <th>Error</th>
                                    <th>Real</th>
                                    <th>Proyección</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nomina.dotacionTitular.map((titular, index) =>
                                    <tr className={titular.idEstadoAprobacion === 1 ? null : cssOperador.thNuevoOperador} key={index}>
                                        <td>{titular.nombreCorto}</td>
                                        <td>{titular.experienciaComoOperador}</td>
                                        <td>{titular.error}</td>
                                        <td>{titular.unidadesContadasReal}</td>
                                        <td>{titular.unidadesContadas}</td>
                                    </tr>
                                )
                                }
                                <tr key={nomina.dotacionTitular.length + 1}>
                                    <td className={cssOperador.tdContNomina} colSpan={4}>Tot. Conteo</td>
                                    <td className={cssOperador.tdContNomina}>{nomina.sumaUnidades}</td>
                                </tr>
                                <tr key={nomina.dotacionTitular.length + 2}>
                                    <td className={cssOperador.tdStock} colSpan={4}>Stock Inv.</td>
                                    <td className={cssOperador.tdStock}>{nomina.local_stock}</td>
                                </tr>
                                <tr key={nomina.dotacionTitular.length + 3}>
                                    <td className={nomina.estadoDiferencia ? cssOperador.tdDifStockPositivo : cssOperador.tdDifStockNegativo} colSpan={4}>Diferencia</td>
                                    <td className={nomina.estadoDiferencia ? cssOperador.tdDifStockPositivo : cssOperador.tdDifStockNegativo}>{nomina.diferenciaUnidades}</td>
                                </tr>
                            </tbody>
                        </table>
                        <label className={cx("col-md-12 control-label", 'labelCantidad')}>Cantidad de Cambios: {nomina.cantCambiosTitular} de {nomina.totalTitular}</label>
                    </div>
                </div>
            </div>
            :
            null
        }
        {nomina.cantCambiosReemplazo > 0 ?
            <div className="col-md-6">
                <div className="panel panel-info">
                    <div className={cx("panel-heading", 'panelHeading')}>Dotación Reemplazo</div>
                    <div className="panel-body">
                        <table className={'table table-striped table-bordered table-hover table-condensed ' + cssOperador.tablaDotacion}>
                            <colgroup>
                                <col className={cssOperador.colNombreM} />
                                <col className={cssOperador.colExp} />
                                <col className={cssOperador.colError} />
                                <col className={cssOperador.colConteoReal} />
                                <col className={cssOperador.colConteo} />
                            </colgroup>
                            <thead className={cssOperador.tHeadSmall}>
                                <tr>
                                    <th colSpan={3}>&nbsp;</th>
                                    <th className={cssOperador.thConteoSpan} colSpan={2}>Conteo</th>
                                </tr>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Exp</th>
                                    <th>Error</th>
                                    <th>Real</th>
                                    <th>Proyección</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nomina.dotacionReemplazo.map((reemplazo, index) =>
                                    <tr className={reemplazo.idEstadoAprobacion === 1 ? null : cssOperador.thNuevoOperador} key={index}>
                                        <td>{reemplazo.nombreCorto}</td>
                                        <td>{reemplazo.experienciaComoOperador}</td>
                                        <td>{reemplazo.error}</td>
                                        <td>{reemplazo.unidadesContadasReal}</td>
                                        <td>{reemplazo.unidadesContadas}</td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </table>
                        <label className={cx("col-md-12 control-label", 'labelCantidad')}>Cantidad de Cambios: {nomina.cantCambiosReemplazo} de {nomina.totalReemplazo}</label>
                    </div>
                </div>
            </div>
            :
            null
        }
        <div className="col-md-12">
            <div className="col-md-7 col-md-offset-3">
                <div className="btn-group" role="group" aria-label="...">
                    <button className={cx("btn btn-md btn-success glyphicon glyphicon-ok", 'glyphicon')} onClick={() => aprobar(nomina.idNomina)} title="Aceptar cambio en la nómina" disabled={enviando}> Aprobar</button>
                    <button className={cx("btn btn-md btn-primary glyphicon glyphicon-envelope", 'glyphicon')} onClick={() => aprobarCorreo(nomina.idNomina)} title="Aceptar cambio en la nómina con correo" disabled={enviando}> Aprobar con Correo</button>
                    <button className={cx("btn btn-md btn-danger glyphicon glyphicon-remove", 'glyphicon')} onClick={() => rechazar(nomina.idNomina)} title="Rechazar cambio en nómina" disabled={enviando}> Rechazar</button>
                </div>
            </div>
        </div>
    </div>
/* BUTTONS */
const BotonAprobar = ({ idNomina, estado, onClickSolicitud }) =>
    <button className="btn btn-xs btn-success" onClick={onClickSolicitud.bind(this, idNomina, estado)}>
        <span className="glyphicon glyphicon-ok"></span>
    </button>

const BotonRechazar = ({ idNomina, estado, onClickSolicitud }) =>
    <button className="btn btn-xs btn-danger" onClick={onClickSolicitud.bind(this, idNomina, estado)}>
        <span className="glyphicon glyphicon-remove"></span>
    </button>

const BotonPublicar = ({ onClickPublicar, disabled }) =>
    <div className={'col-sm-4'}>
        <button className="btn btn-sm btn-success" style={{ width: "100%" }} onClick={onClickPublicar.bind(this, 2)} disabled={disabled}>
            <span className="glyphicon glyphicon-arrow-up"></span> Publicar
        </button>
    </div>

const BotonDespublicar = ({ onClickPublicar, disabled }) =>
    <div className={'col-sm-4'}>
        <button className="btn btn-sm btn-warning" style={{ width: "100%" }} onClick={onClickPublicar.bind(this, 1)} disabled={disabled}>
            <span className="glyphicon glyphicon-arrow-down"></span> Despublicar
        </button>
    </div>

const BadgePendientes = ({ cantidadPendientes }) =>
    <div className="col-sm-4">
        <button className="btn btn-sm btn-info" style={{ width: "100%" }} type="button">
            Pendientes <span className="badge">{cantidadPendientes}</span>
        </button>
    </div>

const ButtonOptionService = ({ service, buttonClassName }) =>
    <button className={buttonClassName} style={{ width: "100%" }}>
        {service.billing_request_id ? <span className='glyphicon glyphicon-envelope'></span> : <span className='glyphicon glyphicon-envelope'></span>}
    </button>

const ButtonIsBilling = ({ service, buttonClassName }) =>
    <button className={buttonClassName} style={{ width: "100%" }}>
        {service.is_billing ? <span className='glyphicon glyphicon-ok-circle'></span> : <span className='glyphicon glyphicon-ban-circle'></span>}
    </button>

export class ModalLiderMasivo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.confirmar = ()=>{
            this.setState({bloqueado: true})
            let cambiosNominas = {}
            cambiosNominas.idLider = this.props.idLiderMasivo
            this.props.liderMultiple(cambiosNominas, this.props.hideModal)
                /*.then(()=>{
                    console.log(this.props.hideModal)
                    this.setState({bloqueado: false})
                    this.props.hideModal()
                    
                })
                .catch(err=>{
                    console.error(err.data)
                })*/
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Favor confirmar la asignación múltiple</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Está seguro de asignar un total de {this.props.totalInventarios} nóminas a {this.props.lider? this.props.lider.nombre1 : 'SIN'} {this.props.lider? this.props.lider.apellidoPaterno : 'LÍDER'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.confirmar} disabled={this.state.bloqueado}>Agregar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}
export class ModalLiderMasivo0Nominas extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.confirmarvolver = ()=>{
            this.props.hideModal()
            this.setState({bloqueado: true})
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>No se han seleccionado nóminas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Por favor seleccione una o más nóminas antes de asignar un líder de forma masiva</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.confirmarvolver} disabled={this.state.bloqueado}>Volver</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export const ModalSuspendidoPago = ({ hideModal, confirmar, cancelar }) => {
    return (
        <Modal show={true} onHide={hideModal} dialogClassName={cx('modalApproveReview')}>
            <Modal.Header closeButton>
                <span className="glyphicon glyphicon-info-sign"></span> ¿Este inventario se suspende con pago?
            </Modal.Header>
            <Modal.Body>
                <h4>Al aceptar, el inventario seguirá con el supervisor seleccionado pero quedará en estado suspendido.</h4>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-success" onClick={() => confirmar()}>Confirmar</button>
                <button type="button" className="btn btn-danger" onClick={() => cancelar()}>Sin pago</button>
                <button type="button" className="btn btn-secondary" onClick={hideModal}>Cerrar</button>
            </Modal.Footer>
        </Modal>
    )
}



// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/Modales.jsx